<template>
  <div class="dnaKits">
    <vx-card class="mb-2">
      <vs-row class="" vs-align="center" vs-justify="space-between">
        <vs-col vs-w="3" >
          <div>
            <h4>Search</h4>
          </div>
        </vs-col>
        <vs-col vs-w="6">
          <!-- SEARCH INPUT -->
          <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg"
            type="text"
            :danger="!!errorMessage.length"
            :danger-text="errorMessage"
            @input="kitId = kitId.toUpperCase()"
            placeholder="Kit Id..."
            size="large"
            v-model="kitId"
            v-on:keyup.enter="fetchKit()"
          />
        </vs-col>
      </vs-row>
    </vx-card>
    <vs-progress v-if="isLoading" indeterminate color="primary" />
    <div class="vx-row">
      <div class="vx-col mt-6 w-1/2">
        <div class="vx-col ">
          <dna-kit :dnaKit="dnaKit" />
        </div>
        <div class="vx-col mt-6">
          <purchased-kit :purchased-kit="purchasedInfo" />
        </div>
      </div>
      <div class="vx-col mt-6 w-1/2">
        <div class="vx-col ">
          <g-g-kit :gg-kit="ggKit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import dnaApi from "@/http/dnaApi";
import DnaKit from "@/views/dna/components/DnaKit";
import GGKit from "@/views/dna/components/GGKit";
import PurchasedKit from "@/views/dna/components/PurchasedKit";

export default {
  components: {
    DnaKit,
    GGKit,
    PurchasedKit
  },
  data() {
    return {
      kitId: "",
      isLoading: false,
      dnaKit: null,
      ggKit: null,
      purchasedInfo: null,
      errorMessage: ""
    }
  },
  methods: {
    async fetchKit() {
      this.errorMessage = "";
      if (!this.kitId || this.kitId === "") {
        this.errorMessage = "Please enter a valid kit id."
        return;
      }
      this.isLoading = true;
      this.dnaKit = await dnaApi.getKitByKitId(this.kitId);
      this.ggKit = await dnaApi.getGGKit(this.kitId);
      this.purchasedInfo = await dnaApi.getPurchasedKits(this.kitId);
      this.isLoading = false;
    }
  }
};
</script>
